import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { siteConfig } from '@/siteConfig';
import { useLanguage } from '@/contexts/LanguageContext';
import { LanguageSwitcher } from './LanguageSwitcher';

export const Footer = () => {
  const { language, t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const navItems = siteConfig.nav[language];
  const routes = siteConfig.routes[language];

  return (
    <footer className="bg-secondary text-secondary-foreground" data-testid="footer">
      <div className="container mx-auto px-4 md:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <div className="font-heading font-bold tracking-tight leading-none">
                <span className="text-primary text-xl">Ng</span>
                <span className="text-accent text-xl">Sys</span>
              </div>
              <div className="text-xs text-muted-foreground font-medium tracking-wide mt-1">
                Automatisation
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              {t(siteConfig.brand.tagline)}
            </p>
            <p className="text-sm text-muted-foreground">
              {t(siteConfig.brand.serviceArea)}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">
              {language === 'fr' ? 'Liens rapides' : 'Quick Links'}
            </h4>
            <ul className="space-y-2">
              {navItems.map((item, index) => (
                <li key={item}>
                  <Link
                    to={routes[index]}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">
              {language === 'fr' ? 'Contact' : 'Contact'}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Mail className="h-4 w-4" />
                <a href={`mailto:${siteConfig.contact.email}`} className="hover:text-primary transition-colors">
                  {siteConfig.contact.email}
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <Phone className="h-4 w-4" />
                <a href={`tel:${siteConfig.contact.phone}`} className="hover:text-primary transition-colors">
                  {siteConfig.contact.phone}
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-muted-foreground">
                <MapPin className="h-4 w-4" />
                <span>{t(siteConfig.contact.address)}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} {siteConfig.brand.companyLegal}. {language === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}
          </p>
          <LanguageSwitcher />
        </div>
      </div>
    </footer>
  );
};